import { render, staticRenderFns } from "./mailbox-home-header-options.vue?vue&type=template&id=e0127218&"
import script from "./mailbox-home-header-options.vue?vue&type=script&lang=ts&"
export * from "./mailbox-home-header-options.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-home-header-options.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports